<template>
  <div class="attention-row" data-testid="attention-row">
    <span
      class="attention-row__pill"
      :aria-label="`${count} item${count === 1 ? '' : 's'} to review`"
    >
      {{ count }}
    </span>

    <div class="attention-row__text">
      <span class="attention-row__title">{{ title }}</span>
      <span v-if="detail" class="attention-row__detail">{{ detail }}</span>
    </div>

    <button
      v-if="actionLabel"
      type="button"
      class="attention-row__action"
      @click="handleAction"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  detail: {
    type: String,
    default: "",
  },
  actionLabel: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["action"]);

function handleAction() {
  emit("action");
}
</script>

<style scoped>
.attention-row {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 12px 0;
  border-top: 1px solid #d0d5dd;
  font-family: Inter, sans-serif;
}

.attention-row__pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  padding: 4px 10px;
  border-radius: 8px;
  background: #eaecf0;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.attention-row__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-width: 0;
}

.attention-row__title {
  color: #101828;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.attention-row__detail {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.attention-row__action {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #7f56d9;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.attention-row__action:hover {
  text-decoration: underline;
}

.attention-row__action:focus-visible {
  outline: 2px solid #6941c6;
  outline-offset: 2px;
}
</style>
